import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { convertDotGroupName } from './utils';

@Directive({
  selector: '[hierarchicalGroupStyle]',
  standalone: false,
})
export class HierarchicalGroupStyleDirective implements OnInit {
  @Input() public groupPath = '';

  @Input() public colorTopLevel = true;

  @Input() public topLevelColor = 'var(--primary-color)';

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    if (!this.groupPath) return;

    const path = this.groupPath.startsWith('/')
      ? this.groupPath
      : convertDotGroupName(this.groupPath);

    const parts = path.split('/').filter(Boolean);
    const level = parts.length;

    this.renderer.setStyle(
      this.el.nativeElement,
      'padding-left',
      `${(level - 1) * 4}px`
    );

    if (this.colorTopLevel && level === 1) {
      this.renderer.setStyle(
        this.el.nativeElement,
        'color',
        `var(--primary-color, ${this.topLevelColor})`
      );
      this.renderer.setStyle(this.el.nativeElement, 'font-weight', '500');
    }
  }
}
